import { Link } from "react-router-dom";

const ROLES = [
  { title: "Lab Sous-Chef", type: "Full-time · Karnataka", body: "Work alongside our founding lab team — recipe development, prototype testing, kitchen ops." },
  { title: "Brand & Content Lead", type: "Full-time · Remote / Hybrid", body: "Own the Pop Panda voice — content, photography direction, social storytelling." },
  { title: "Operations Associate", type: "Full-time · Karnataka", body: "Manage daily production planning, inventory, and supplier coordination." },
];

export default function Careers() {
  return (
    <div data-testid="careers-page" className="section-pad">
      <div className="container-pp">
        <div className="text-[11px] uppercase tracking-[0.22em] text-brand-charcoal/55">Careers</div>
        <h1 className="editorial-h1 text-5xl md:text-7xl mt-3">Make popsicles for a living.</h1>
        <p className="mt-6 max-w-xl text-brand-charcoal/70 leading-relaxed">We're a small, ambitious team based in Karnataka. We hire for curiosity, care and craft.</p>
        <div className="mt-12 grid lg:grid-cols-3 gap-6">
          {ROLES.map((r) => (
            <div key={r.title} className="card-elevated p-7">
              <div className="text-[11px] uppercase tracking-[0.22em] text-brand-red">{r.type}</div>
              <div className="font-display text-3xl mt-2">{r.title}</div>
              <p className="mt-3 text-sm text-brand-charcoal/70 leading-relaxed">{r.body}</p>
              <Link to="/contact" data-testid={`career-apply-${r.title}`} className="btn-pill btn-dark mt-6 text-xs">Apply via Contact</Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
